import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createVNode as _createVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1>Scannen Sie Ihren Skipass...</h1><div id=\"ski-pass-wrapper\"><div class=\"scan-circle\"></div><div class=\"scan-circle\" style=\"animation-delay:0.2s;\"></div><div class=\"scan-circle\" style=\"animation-delay:0.4s;\"></div><div id=\"ski-pass\"></div></div>", 2)
const _hoisted_4 = [
  _hoisted_2
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Wir bitten Sie beim ersten mal einzuchecken", -1)
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", null, "Gäste", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Check-ins")
], -1)

import { ref, reactive, computed, watch, onMounted } from 'vue'
import JSConfetti from 'js-confetti'
import { setIntervalX } from '@/api/utils'
import store from '@/store'

import MenuItems from '@/components/MenuItems.vue'
import PhotoBooth from '@/components/PhotoBooth.vue'
import CartDrawer from '@/components/CartDrawer.vue'
import OrderConfirmation from '@/components/OrderConfirmation.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const jsConfetti = new JSConfetti()

const audioCount = new Audio('/beer.mp3')
const audioWelcome = new Audio('/welcome.mp3')
const audioAnne = new Audio('/anne.mp3')
const audioDing = new Audio('/ding.mp3')

const state = reactive({
  showPhotoBooth: false
})

const onPhoto = (photo: string) => {
  currentUser.value && store.setUserPhoto(currentUser.value?.id, photo)
  state.showPhotoBooth = false
  store.signOut()
}

const currentUser = computed(() => store.getCurrentUser())
const users = store.get(state => state.users)

const userName = ref('')
const sortedUsers = computed(() => Object.values(users.value).sort((a,b) => b.scanCount - a.scanCount) )
const capitalize = (str: string) => str // str.charAt(0).toUpperCase() + str.slice(1)

const welcome = () => {
  audioWelcome.play()
  state.showPhotoBooth = true
  setIntervalX(() => {
    jsConfetti.addConfetti({
      //emojis: ['🌈', '⚡️', '💥', '✨', '💫', '⛷️'],
    })
  }, 1000, 6)
}

const checkIn = () => {
  welcome()
  createUser()
}

watch(currentUser, user => {
  userName.value = ''
  if (user && !user.registered) {
    //
  } else if (user) {    
    if (user.name && user.name.toLowerCase().includes('anne')) {
      audioAnne.play()
    }
  }
})

const createUser = () => {
  const user = currentUser.value
  if (user && !user.registered) {
    store.createUser(user.id, userName.value)
  }
  userName.value = ''
}

const vFocus = {
  mounted: (el: HTMLElement) => el.focus()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(currentUser))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : (!_unref(currentUser)?.registered)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("h1", null, "Wilkommen " + _toDisplayString(capitalize(userName.value)) + " ❄️", 1),
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userName).value = $event)),
              onKeypress: _cache[1] || (_cache[1] = _withKeys(($event: any) => (checkIn()), ["enter"]))
            }, null, 544), [
              [
                _vModelText,
                userName.value,
                void 0,
                { trim: true }
              ],
              [vFocus]
            ]),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (checkIn())),
              style: {"margin-left":"1rem"},
              disabled: !userName.value
            }, "Einchecken", 8, _hoisted_7)
          ]))
        : (_unref(currentUser))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(MenuItems)
            ]))
          : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "slideUp" }, {
      default: _withCtx(() => [
        (state.showPhotoBooth)
          ? (_openBlock(), _createBlock(PhotoBooth, {
              key: 0,
              countdown: 7,
              onPhoto: onPhoto
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("table", null, [
            _hoisted_11,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedUsers), (user) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: user.id
              }, [
                _createElementVNode("td", null, _toDisplayString(user.name || '-'), 1),
                _createElementVNode("td", null, _toDisplayString(user.scanCount), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})